// components/Favorites.js — ФИНАЛЬНАЯ РАБОЧАЯ ВЕРСИЯ
import React from "react";

export default function Favorites({ favorites, applyFavorite, deleteFavorite, getContrastYIQ }) {
  if (!favorites || favorites.length === 0) return null;

  const showToast = (msg, type = "info") => {
    window.dispatchEvent(new CustomEvent("showToast", { detail: { msg, type } }));
  };

  const handleApply = (fav) => {
    applyFavorite(fav);
    showToast("Стиль применён из избранного!", "success");
  };

  const handleDelete = (e, fav) => {
    e.stopPropagation();
    deleteFavorite(fav);
  };

  return (
    <div
      style={{
        margin: "30px 0",
        padding: "20px",
        background: "rgba(255, 255, 255, 0)",
        borderRadius: "30px",
        animation: "zoomIn alternate 1.5s",
        width: "90%",
        maxWidth: "500px",
        boxSizing: "border-box",
                maxWidth: "200px",
      }}
    >
      <h3
        style={{
          color: "white",
          textAlign: "center",
          margin: "0 0 20px 0",
          fontSize: "14px",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
     <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>  {favorites.length}/5
      </h3>

      <div
        className="tools-conteiner"
        style={{
          gap: "18px",
          justifyContent: "center",
          
        }}
      >
        {favorites.map((fav, index) => {
          // Определяем фон карточки
          const cardBackground = fav.gradient
            ? fav.gradient
            : fav.customColor || "#666";

          return (
            <div
              key={index}
              onClick={() => handleApply(fav)}
              style={{
                flex: "0 1 calc(50% - 20px)",
                maxWidth: "calc(50% - 20px)",
                minWidth: "100px",
                borderRadius: "25px",
                padding: "20px",
                cursor: "pointer",
                position: "relative",
                transition: "all 0.3s ease",
                boxShadow: "0 0 15px rgba(0,0,0,0.4)",
                animation: "zoomIn alternate 1s",
                background: cardBackground,
                overflow: "hidden",
                
                
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-8px) scale(1.03)";
                e.currentTarget.style.boxShadow = "0 0 25px rgba(0,0,0,0.6)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "0 0 15px rgba(0,0,0,0.4)";
              }}
            >
       
              <div
                style={{
                  position: "absolute",
                  top: 0, left: 0, right: 0, bottom: 0,
                  background: "rgba(0,0,0,0.45)",
                  borderRadius: "25px",
                  
                  
                }}
              />

              {/* Контент */}
              <div style={{ position: "relative", zIndex: 2 }}>
                <p
                  style={{
                    margin: "0 0 14px 0",
                    fontWeight: "bold",
                    color: "white",
                    fontSize: "12px",
                    fontFamily: fav.font ? `'${fav.font}', sans-serif` : "'Montserrat', sans-serif",
                    textAlign: "center",
                    textShadow: "2px 2px 8px rgba(0,0,0,0.8)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    
                  }}
                  title={fav.font}
                >
                  {fav.font || "Без шрифта"}
                </p>

                <div
                  style={{
                    background: "rgba(0,0,0,0.7)",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: "bold",
                    display: "inline-block",
                    margin: "0 auto",
                    backdropFilter: "blur(4px)",
                  }}
                >
                  {fav.customColor || "Градиент"}
                </div>
              </div>

              {/* Кнопка удаления */}
              <button
                onClick={(e) => handleDelete(e, fav)}
                style={{
                  position: "absolute",
                  top: "2px",
                  right: "2px",
                  width: "30px",
                  height: "30px",
                  background: "rgba(255, 50, 50, 0.95)",
                  color: "white",
                  border: "none",
                  borderRadius: "50%",
                  fontSize: "22px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.6)",
                  zIndex: 3,
                }}
              >
                ×
              </button>

              {/* Подсказка */}
              <div
                style={{
                  position: "absolute",
                  bottom: "14px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  background: "rgba(0,0,0,0.8)",
                  color: "#4ade80",
                  padding: "5px 14px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "bold",
                  opacity: 0,
                  transition: "opacity 0.3s",
                  pointerEvents: "none",
                  zIndex: 3,
                }}
              >
                Клик — применить
              </div>
            </div>
          );
        })}
      </div>

      <style jsx>{`
        div[style*="cursor: pointer"]:hover > div:last-child {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}